exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hover-hand {\r\n    cursor: pointer;\n}\r\n", ""]);

// exports
